import React, { useEffect, useRef, useState } from "react";
// import Loaders from "../Loaders";
import { API_ROUTES } from "../../../utils/constants";
import Nulls from "../Nulls";
import TopNav from "../TopNav";
import Notifications from "../Notifications";
import NavHeader2 from "../NavHeader2";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import MarketerReportTable from "./MarketerReportTable";
import BreadcrumTop from "../BreadcrumTop";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";

export default function ListOfMarketers(props) {
  const {
    // companyId,
    objectToFormData,
    errorFunction,
    Helmet,
    isLoaded,
    isAuthExpired,
    capitalizeWords,
  } = props;

  useEffect(() => {
    setIsLoading(true);

    setIsLoading(false);
  }, []);

  useEffect(() => {
    document.title = "List Of Marketers ";
  }, []);

  const location = useLocation();
  const navigate = useNavigate();
  const rowData = location.state?.rowData;

  

  useEffect(() => {
    if (rowData) {
      // console.log("Company ID from row:", rowData);
      setCompanyId(rowData.id);
      setCompanyName(rowData.companyName);

      const companyVASData = {
        id: rowData.id,
        companyName: rowData.companyName,
      };

      // Store in local storage
      localStorage.setItem("companyVASData", JSON.stringify(companyVASData));

      // console.log("Stored in localStorage:", companyVASData);
    }
  }, [rowData]);
  
  

  const [isLoading, setIsLoading] = useState(true);
  // const [dataTotal, setDataTotal] = useState(0);
  const [dataList, setDataList] = useState([]);
  const [columns, setColumns] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 20;
  const [isFade, setIsFade] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [companyId, setCompanyId] = useState("");

  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    let script;
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };
    Promise.all([loadScript("../assets/libs_/js/custom.min.js")])
      .then(() => {
        // Both scripts are loaded
      })
      .catch((error) => {
        console.error("Error loading scripts:", error);
      });
    return () => {
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const columns1 = [
    {
      name: " Name",
      selector: (row) => (row.name ? row.name : <Nulls />),
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => (row.email ? row.email : <Nulls />),
    },

    {
      name: "PID",
      selector: (row) => (row.pId ? row.pId : <Nulls />),
    },
    {
      name: "Unit Price",
      selector: (row) => (row.unitPrice ? row.unitPrice : <Nulls />),
    },
  ];

  useEffect(() => {
    setColumns(columns1);
  }, []);

  // Function to handle filter input change
  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  // Filtered data based on filterText
  const filteredData = dataList.filter((company) => {
    return (
      company.name?.toLowerCase().includes(filterText.toLowerCase()) ||
      company.email?.toLowerCase().includes(filterText.toLowerCase())
    );
  });

  // useEffect(() => {
  //   console.log("data list",dataList);
  // }, [dataList]);

  return (
    <>
      {/* <Loaders isLoaded={isLoaded} /> */}

      <div id="main-wrapper" className={isLoaded ? "show" : ""}>
        <TopNav />
        <Notifications />
        <NavHeader2 />
        <Sidebar />

        <div className="content-body mt--10">
          <div className="container-fluid pl-xs-0 pr-xs-0 pt-xs-0">
            <BreadcrumTop title="Marketers" />

            <div className="row ">
              {/* Filter input */}
              {/* <div className="container d-flex justify-content-between align-items-center mb-4"> */}
              <div className="container d-flex justify-content-end align-items-center mb-4">
                {/* Span on the far left */}
                {/* <h5 className="bg-primary text-light  text-uppercase  px-2 py-2">
                  {companyName
                    ? capitalizeWords(companyName)
                    : "Unknown Company"}
                </h5> */}

                {/* filter */}
                <div className="col-md-5 col-sm-12  mx-1 d-flex justify-content-end">
                  <input
                    type="text"
                    placeholder="Enter Name or Email"
                    value={filterText}
                    onChange={handleFilterChange}
                    className="form-control"
                  />
                  <div className="col-md-5 col-sm-12 mx-1">
                    <Link
                      to="/marketer/create"
                      state={{ companyId: companyId }}
                      className="btn btn-primary"
                    >
                      Create Marketer
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <MarketerReportTable
                capitalizeWords={capitalizeWords}
                // dataList={dataList}
                dataList={filteredData}
                setDataList={setDataList}
                // dataTotal={dataTotal}
                isLoading={isLoading}
                columns={columns}
                countPerPage={countPerPage}
                setPage={setPage}
                isFade={isFade}
                setIsFade={setIsFade}
                isAuthExpired={isAuthExpired}
                objectToFormData={objectToFormData}
                setColumns={setColumns}
                companyName={companyName}
                setCompanyName={setCompanyName}
                companyId={companyId}
                setCompanyId={setCompanyId}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
